import { IRbacProvider } from 'slipstream-components';
import DefaultAuthProvider from './DefaultAuthProvider';

export default class DefaultRbacProvider implements IRbacProvider {
  private authProvider: DefaultAuthProvider;

  constructor(auth: DefaultAuthProvider) {
    this.authProvider = auth;
  }

  public verifyAccess(requiredCaps: string[]) {
    if (requiredCaps == null || requiredCaps.length === 0) {
      return true;
    }
    const capabilities = this.authProvider.getCapabilities() || [];
    let roleFound = false;
    const cfgFound = true;
    let featureFound = false;
    let propertyFound = false;
    let scopeFound = true;
    let platformFound = true;

    const featureConfigs = requiredCaps.filter(
      c =>
        c.startsWith('config:') ||
        c.startsWith('feature:') ||
        c.startsWith('scope:') ||
        c.startsWith('prop:') ||
        c.startsWith('platform:')
    );

    let featureRequired = 0;
    let propertyRequired = 0;
    featureConfigs.forEach(c => {
      // if (c.startsWith('config:')) {
      //     if (!this.isConfigMatch(c)) {
      //         cfgFound = false;
      //     }
      // }
      if (c.startsWith('feature:')) {
        featureRequired++;
        if (this.isFeatureMatch(c)) {
          featureFound = true;
        }
      } else if (c.startsWith('prop:')) {
        propertyRequired++;
        if (this.isPropertyMatch(c)) {
          propertyFound = true;
        }
      } else if (c.startsWith('scope:')) {
        if (!this.isScopeMatch(c)) {
          scopeFound = false;
        }
      } else if (c.startsWith('platform:')) {
        if (!this.isPlatformMatch(c)) {
          platformFound = false;
        }
      }
    });

    // features themselves should be "OR"
    if (featureRequired === 0) {
      featureFound = true;
    }

    if (propertyRequired === 0) {
      propertyFound = true;
    }

    const roleCapabilities = requiredCaps.filter(
      c =>
        !c.startsWith('config:') &&
        !c.startsWith('feature:') &&
        !c.startsWith('scope:') &&
        !c.startsWith('platform:')
    );

    if (roleCapabilities.length === 0) {
      roleFound = true;
    } else {
      for (const c of roleCapabilities) {
        if (capabilities.indexOf(c) !== -1) {
          roleFound = true;
          break;
        }
      }
    }
    return cfgFound && roleFound && featureFound && scopeFound && propertyFound && platformFound;
  }

  /**
   * Verify that the feature capability matches an entry
   *
   * @param String capability - Feature string
   *          "feature: name1"
   *
   * @returns - true if any of the feature capability matches an entry
   */
  private isFeatureMatch(capability) {
    const features = this.authProvider.getFeatures();
    if (features == null || features.length === 0) {
      return false;
    }
    const featureStr = capability.split(':')[1].trim();
    return features.indexOf(featureStr) !== -1;
  }

  /**
   * Verify if the property in tenant matches an entry
   *
   * @param String capability - Feature string
   *          "property: name1"
   *
   * @returns - true if any of the feature capability matches an entry
   */
  private isPropertyMatch(capability) {
    const segs = capability.split(':');
    const key = segs[1];
    const value = segs[2];
    const properties = this.authProvider.getTenantProperties();
    if (properties == null) {
      return false;
    }
    let propValue = properties[key];
    if (propValue === undefined) {
      if (properties.property) {
        const props = properties.property.filter(p => p.name === key);
        if (props.length > 0) {
          propValue = props[0].value;
        }
      }
    }

    // didn't find
    if (propValue === undefined) {
      return false;
    }

    // only match key
    if (value === undefined) {
      return true;
    }

    return propValue === value;
  }

  /**
   * Verify that the scope capability matches an entry
   *
   * @param String scope - scope string
   *          "scope: name1"
   *
   * @returns - true if the scope matches the context's scope
   */
  private isScopeMatch(scope) {
    const scopeStr = scope.split(':')[1].trim();
    return scopeStr === this.authProvider.getRoleScope();
  }

  private isPlatformMatch(platform) {
    const platformStr = platform.split(':')[1].trim();
    if (platformStr === 'both') {
      return true;
    } else if (platformStr === 'mobile') {
      const mobileFlag = sessionStorage.getItem('mobile');
      if (mobileFlag === 'true') {
        return true;
      }
    } else if (platformStr === 'pc') {
      const mobileFlag = sessionStorage.getItem('mobile');
      if (mobileFlag === 'false' || mobileFlag == null) {
        return true;
      }
    }

    return false;
  }

  // /**
  //  * Verify that the config capability matches an entry from configCache
  //  *
  //  * @param String capability - Config string
  //  *          "config: <config-name>=<config-value1>,<config-value2>..." -OR-
  //  *          "config: <config-name>" if we are simply checking on existence
  //  *
  //  * @returns - true if any of the config capability matches an entry from configCache
  //  */
  // private isConfigMatch(capability) {
  //     configCache = this._configCache || {};

  //     // get the value after the prefix "config:" string
  //     var cfgStr = capability.split(':')[1].trim()
  //     if (!cfgStr) {
  //         // incomplete capability check. ignore it
  //         return true
  //     }

  //     // the cfgStr will be "key=val1,val2..."
  //     var cfgPair = cfgStr.split('=')
  //     var cfgName = cfgPair[0].trim()

  //     if (cfgPair.length > 1) {
  //         // check if any of the values match
  //         var cfgValues = cfgPair[1].split(',');
  //         for (var j = 0; j < cfgValues.length; j++) {
  //             var cfgValue = cfgValues[j].trim();
  //             if (configCache[cfgName] == cfgValue) {
  //                 return true;
  //             }
  //         }
  //         return false;

  //     } else {
  //         // just check if the config value exist in configCache
  //         return configCache[cfgName] ? true : false;
  //     }
  // };
}
